import stylesheet from './Notification.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";
import {getIconStyles} from "../../util/lazy";

const TYPES = ['error', 'success', 'warning', 'info', 'neutral'];
const VARIANTS = ['single-line', 'multi-line'];

export class NXTNotification extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
        void this.appendStyleLazy(getIconStyles);
    }

    get type(): string {
        const value = this.getAttribute('type');
        return value && TYPES.includes(value) ? value : 'info';
    }

    get variant(): string {
        const value = this.getAttribute('variant');
        return value && VARIANTS.includes(value) ? value : 'single-line';
    }

    get closable(): boolean {
        return !this.hasAttribute('no-close');
    }

    get labelClose(): string {
        return this.getAttribute('label-close') ?? 'Close';
    }

    render() {
        const notification = document.createElement('div');
        notification.classList.add('notification', `notification-${this.type}`, `notification-${this.variant}`);
        notification.setAttribute('role', 'status');

        notification.innerHTML = `
            <span class="notification-icon" aria-hidden="true"></span>
            <div class="notification-text">
                <div class="notification-title"><slot name="title">Notification title</slot></div>
                <div class="notification-message"><slot name="message">Notification message</slot></div>
            </div>
        `;

        if (this.closable) {
            const closeButton = document.createElement('button');
            closeButton.type = 'button';
            closeButton.classList.add('notification-close');
            closeButton.setAttribute('aria-label', this.labelClose);
            closeButton.innerHTML = `<span class="notification-close-icon" aria-hidden="true"></span>`;
            closeButton.addEventListener('click', () => {
                this.dispatchEvent(new CustomEvent('close', {bubbles: true, composed: true}));
                this.hidden = true;
            });
            notification.appendChild(closeButton);
        }

        return notification;
    }
}

customElements.define('nxt-notification', NXTNotification);
